import { Route } from '@app/core/enums/route.enum';
import {
  ProfileLayoutBlock,
  ProfileLayoutBlockType,
  ProfileLayoutTileActionType,
  ProfileLayoutTileType,
} from '@app/core/types/profile/profile-layout.types';

/** In-app destinations for tiles without a link action. */
export const profileTileRoutes: Partial<Record<string, Route>> = {
  [ProfileLayoutTileType.Loyalty]: Route.Loyalty,
  [ProfileLayoutTileType.About]: Route.About,
  [ProfileLayoutTileType.Documents]: Route.Documents,
};

/** Skips in-app tiles this app version can't navigate to, so they don't render as dead tiles. */
export const isSupportedBlock = (block: ProfileLayoutBlock): boolean => {
  if (block.type !== ProfileLayoutBlockType.Tile) {
    return true;
  }
  return block.tile.action?.type === ProfileLayoutTileActionType.Link || !!profileTileRoutes[block.tile.type];
};
